




































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import MessagesHistory from "@/modules/messaging/components/MessagesHistory.vue";
import MessageSendingForm from "@/modules/messaging/components/MessageSendingForm.vue";
import PlushieInfo from "@/modules/plushie/components/PlushieInfo.vue";
import ArtworkGallery from "@/modules/plushie/components/ArtworkGallery.vue";

import PlushieStore from "@/modules/plushie/store";
import dataStore from "@/store";
import Plushie from "@/modules/plushie/plushie.model";

@Component({
  metaInfo() {
    const component = this as MessageReplyPage;

    let titlePrefix = "";
    if (component.plushie != null) {
      titlePrefix = component.plushie.storeItemId + " - ";
    }

    return {
      title: titlePrefix + "Designer Q&A",
    };
  },
  components: {
    MessagesHistory,
    MessageSendingForm,
    PlushieInfo,
    ArtworkGallery,
  },
})
export default class MessageReplyPage extends Vue {
  @Prop({ required: true })
  public plushieId!: string;

  private fPlushieDataStore: PlushieStore;
  private fHasAutoScrolled = false;

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  constructor() {
    super();

    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  public async onMessagesLoaded(): Promise<void> {
    if (this.fHasAutoScrolled) {
      return;
    }

    this.fHasAutoScrolled = true;
    const sendingForm = this.$refs["sending-form"] as
      | InstanceType<typeof MessageSendingForm>
      | undefined;

    if (!sendingForm) {
      return;
    }

    await this.$nextTick();

    const bottomAnchor = sendingForm.$el;
    bottomAnchor.scrollIntoView({ behavior: "smooth", block: "end" });
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    this.fHasAutoScrolled = false;
    await this.fPlushieDataStore.loadPlushieById({ id: this.plushieId });
  }
}
